import { render, staticRenderFns } from "./LoadingSpinner.vue?vue&type=template&id=ce56d638&scoped=true&"
import script from "./LoadingSpinner.vue?vue&type=script&lang=js&"
export * from "./LoadingSpinner.vue?vue&type=script&lang=js&"
import style0 from "@/styles/components/LoadingSpinner/LoadingSpinner.less?vue&type=style&index=0&id=ce56d638&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce56d638",
  null
  
)

export default component.exports